// extracted by mini-css-extract-plugin
module.exports = {"menuApiGrid":"menuApi_menuApiGrid__rHePZ","menuApiGridSize":"menuApi_menuApiGridSize__7Po6i"};